import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardRouting } from './dashboard.routing';
import { LoadMyGamesCommandHandler } from '@my-games';
import { MyGamesService, MyGamesStorage } from '@my-games/infra';
import { TeamsService } from '@teams/infra';
import { PenaltiesService } from '@fair-play/infra';

@NgModule({
  imports: [RouterModule.forChild(DashboardRouting)],
  providers: [MyGamesService, MyGamesStorage, LoadMyGamesCommandHandler, TeamsService, PenaltiesService]
})
export class DashboardModule {}
